import React, { PureComponent } from 'react'
import { APP_URL, DIMENSION_ATTRIBUTES, SHAPE_ATTRIBUTES_MAP } from '../utils/config.js'
import {
  setCanProceedToNextStep,
  setCategory,
  setSelectedDimensions,
  setSelectedShape,
  setSelectedType,
} from '../actions/generalActions.js'
import { connect } from 'react-redux'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import { BarLoader } from 'react-spinners'
import { displayToast, sendGtag } from '../utils/utils.js'
import { setCurrentFlow } from '../actions/layoutActions.js'
import _ from 'lodash'
import { setInitialCushionDimensions, setIsHalfInchRemoved } from '../actions/cushionActions.js'

class CushionTypeSelector extends PureComponent {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    const { dispatch, general } = this.props
    const { type } = general

    dispatch(setCanProceedToNextStep(type !== null))
  }

  componentDidUpdate(prevProps) {
    const { params, cushion, dispatch, history } = this.props
    const { cushionTypes } = cushion

    if (prevProps.cushion.cushionTypes === null && cushionTypes !== null) {
      if (params.type.id !== 'type' && parseInt(params.type.id)) {
        let selectedType = cushionTypes.find((type) => type.id.toString() === params.type.id)
        if (selectedType) {
          dispatch(setCanProceedToNextStep(true))
        } else {
          history.push(`/cd/${params.category}/type`)
          displayToast(
            'The URL you were trying to access is broken. Please reselect your options',
            'error',
          )
        }
      }
    }
  }

  _setFlow = (type) => {
    const { dispatch, layout } = this.props
    const { currentFlow } = layout
    const category = type.categories.filter((category) =>
      [27, 28, 769, 884, 2893].includes(category.id),
    )[0]?.id
    let flow = 'default'

    switch (category) {
      case 28:
        flow = 'deep-seating'
        break
      case 27:
        flow = 'pillow'
        break
      case 2893:
        flow = 'filling-only'
        break
    }

    if (flow !== currentFlow) {
      dispatch(setCurrentFlow(flow))
    }
  }

  _getDimensionsDataFromAPI = (dispatch, shape, type) => {
    const { params, layout } = this.props
    const { typesStepView } = layout
    const cushionDimensions = {}

    SHAPE_ATTRIBUTES_MAP[
      typesStepView !== 'allTypes' || params.type?.custom ? 859 : shape.id || type.id
    ].map((dimensionId) => {
      let currentAttribute = type.attributes.find(
        (attribute) => attribute.id.toString() === dimensionId.toString(),
      )
      cushionDimensions[DIMENSION_ATTRIBUTES[dimensionId]] = currentAttribute?.options
    })

    if (params.dimensions) {
      const dimensionsFromParams = this._getDimensionsFromParams(cushionDimensions)
      dispatch(setSelectedDimensions(dimensionsFromParams))
    }

    dispatch({ type: 'FETCH_ATTRIBUTE_TERMS_BY_ID_SUCCESS' })
    dispatch(setInitialCushionDimensions(cushionDimensions))
  }

  _selectCushionType = (type) => () => {
    const { dispatch, layout, cushion, general, history } = this.props
    const { typesStepView, category: currentCategory } = layout
    const { dimensions } = general
    const category = type.categories.filter((category) =>
      [27, 28, 769, 884, 2893].includes(category.id),
    )[0]?.id
    const { cushionShapes, isHalfInchRemoved } = cushion

    if (general?.type?.id !== type?.id) {
      sendGtag('add_type', `${type?.name}`)
    }

    // if (type.name.toLowerCase().includes('custom')) {
    // 	this._toggleCustomTemplateTutorial();
    // }

    if (category !== currentCategory) {
      dispatch(setCategory(category))
    }

    if (typesStepView === 'allTypes') {
      this._setFlow(type)
    } else {
      const customCushion = cushionShapes?.find((shape) => shape.id === 859)
      dispatch(setSelectedShape(customCushion))
      this._getDimensionsDataFromAPI(dispatch, customCushion, type)
    }

    if (!_.isEmpty(dimensions)) {
      dispatch(setSelectedDimensions({}))
    }
    dispatch(setSelectedType(type, true))
    if (isHalfInchRemoved) {
      dispatch(setIsHalfInchRemoved(false))
    }

    const idsWithShapeAsNextStep = [13101, 11660, 11658, 12072, 12107, 11568]
    const idCustom = 11741
    const idsWithDimensionAsNextStep = [11858, 168, 11860]
    const idsWithSetAsNextStep = [166, 11786, 11864, 12090]

    sendGtag('next_button_type')
    // if (type?.id === idCustom) return;
    if (idsWithShapeAsNextStep.includes(type?.id)) {
      history.push(`/cd/${category}/${type?.id}-${type?.slug}/shape`)
    }
    if (idCustom === type?.id) {
      history.push(`/cd/${category}/${type?.id}-${type?.slug}/shape`)
    }
    if (idsWithDimensionAsNextStep.includes(type?.id)) {
      history.push(`/cd/${category}/${type?.id}-${type?.slug}/dimensions`)
    }
    if (idsWithSetAsNextStep.includes(type?.id)) {
      history.push(`/cd/${category}/${type?.id}-${type?.slug}/set`)
    }
  }

  _getTypeImage = (param) => {
    try {
      return require(`../../assets/type/${param}.webp`).default
    } catch (error) {
      console.log('Failed to load image:', error) //eslint-disable-line
      return ''
    }
  }

  _renderCushionTypes = () => {
    const { general, cushion, layout, params } = this.props
    const { type } = general
    const { cushionTypes } = cushion
    const { typesStepView } = layout
    let cushionTypesCopy = _.cloneDeep(cushionTypes)

    if (cushionTypesCopy !== null) {
      cushionTypesCopy.map((cushionType) => {
        if (cushionType.name === 'Ottoman') {
          cushionType.images[0].src = `${APP_URL}/wp-content/uploads/2022/01/ottoman-1.png`
        }
      })
    }

    const typesCopy = _.reject(
      cushionTypesCopy,
      (cushionType) => cushionType.name === 'Chair with Back',
    )

    const copyOfTypes = [...typesCopy]

    if (cushionTypes === null) {
      return <BarLoader color={'#93C44E'} css={{ position: 'absolute' }} />
    }

    if (typesStepView !== 'allTypes') {
      cushionTypesCopy = cushionTypesCopy.filter((type) => [11864, 12090, 11786].includes(type.id))
    }

    const renderedCushions = []
    const customCard = 11741

    if (cushionTypes.length > 0) {
      renderedCushions.push(
        ...copyOfTypes.map((cushion, index) => {
          return (
            <div
              id={`cushion-type-${index}`}
              key={cushion.id}
              onClick={this._selectCushionType(cushion)}
              className={`cushion-type-selector-card ${type?.id === cushion.id ? 'active' : ''}`}
            >
              <div className={'cushion-type-selector-card-checkbox'}>
                {type?.id === cushion.id && (
                  <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
                )}
              </div>
              <img className={'type-image'} src={this._getTypeImage(cushion.slug)} />
              <div
                className={`card-title ${customCard === cushion.id && !params.set ? 'custom-card-h3' : ''}`}
              >
                {cushion.name}
              </div>
            </div>
          )
        }),
      )
    }

    return renderedCushions
  }

  render() {
    const slides = Array.from(this._renderCushionTypes())
    return (
      <div className="cushion-type-selector type">
        {slides}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  cushion: state.cushion,
  layout: state.layout,
})

export default withRoutingTracker(connect(mapStateToProps)(CushionTypeSelector))
